// mtrx_btn has no schema style domain (parts: {}) — HaspButtonmatrix computes
// item_buttons style once and pushes plain values directly into each
// HaspMtrxButton child's Konva shapes (see HaspButtonmatrix.js drawButtons()).
// This theme entry is never consulted, so it is deliberately left empty.
export function mtrx_btn(_ctx) {
    return {};
}
